import React, { useEffect, useState } from 'react'
import { isAuthenticated } from "../api/api";

const ChatInput = ({handleSendMessage, enable, selectedMessage}) => {
    const [message, setMessage] = useState('');
    const [buttonEnabled, setButtonEnabled] = useState(false);

    const handleKeyDown = (e) => {
        if (e.isComposing || e.keyCode === 229) {
            // IME入力中の場合はEnterキーを無視（変換確定のため）
            return;
        }
    
        if (e.key === 'Enter' && e.shiftKey) {
            // Shift + Enter で改行
            e.preventDefault();
            setMessage(prevMessage => prevMessage + '\n');
        } else if (e.key === 'Enter' && buttonEnabled) {
            // Enter でメッセージ送信
            e.preventDefault();
            handleSendMessage(e, message);
            setMessage(''); // メッセージ送信後にテキストエリアをクリア
        }
    };
    

    useEffect(() => {
        if (message.trim().length > 0) {
            setButtonEnabled(enable);
        } else {
            setButtonEnabled(false);
        }
    }, [message]);

    const onSendMessageClick = (e) => {
        e.preventDefault();
        if (buttonEnabled) {
            handleSendMessage(e, message);
        }
    }
    
    useEffect(() => {
        if (selectedMessage) {
            setMessage(selectedMessage);
        }
    }, [selectedMessage])

    return (
        <div className="search-company-input chat-input">
            <div className="textarea-icon-container">
                <i className="fa-regular fa-message textarea-icon"></i>
                <textarea 
                    id="main-chat" 
                    className="search-area extra-wide-search-area" 
                    name="message" 
                    placeholder={isAuthenticated() ? "質問してください"  : "チャットをするにはログインが必要です"}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    onKeyDown={handleKeyDown}
                    disabled={!isAuthenticated()} // 未ログインならボタン無効
                    >
                </textarea>
                <i className={`fa-solid fa-angles-up exe-chat-icon ${buttonEnabled ? "": "button-disabled"}`} onClick={onSendMessageClick}></i>
            </div>
        </div>
    )
}

export default ChatInput